import { render, staticRenderFns } from "./ModalDeletePhoneNumber.vue?vue&type=template&id=d2843eb8&"
import script from "./ModalDeletePhoneNumber.vue?vue&type=script&lang=js&"
export * from "./ModalDeletePhoneNumber.vue?vue&type=script&lang=js&"
import style0 from "./ModalDeletePhoneNumber.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports